import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { useAuthentication } from '../customHooks/useAuthentication'
import { userMatchesRoleAccess } from '../utils/userRole'
import paths from './paths'

/**
 * Route guard by company app role (`roles[].name`, e.g. admin, employee).
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string[]} [props.allow] - User must have at least one of these roles (case-insensitive).
 * @param {string[]} [props.deny] - User must not have any of these roles.
 * @param {string} [props.redirectTo] - Defaults to paths.accessDenied.
 */
export default function RoleGuardRoute({ children, allow, deny, redirectTo = paths.accessDenied }) {
  const { userInfo } = useAuthentication()
  const location = useLocation()
  if (!userMatchesRoleAccess(userInfo, { allow, deny })) {
    return <Redirect to={{ pathname: redirectTo, state: { from: location } }} />
  }
  return children
}
